const Mock = require('mockjs');
const List = [{
    id: 0,
    siteName: "YRY",
    path: "https://www.yuerongyi.top",
    desc: "技术分享"
}]
const count = 5

for (let i = 0; i < count; i++) {
    List.push(Mock.mock({
        id: '@increment',
        siteName: "@cname",
        path: "@url",
        desc: "@ctitle(5,20)"
    }))
}

export default [
    {
        url: '/friend',
        type: 'get',
        response: config => {
            return {
                code: 20000,
                data: List
            }
        }
    }
]